import { mainSiteUrl } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-12 md:py-16 px-4 md:px-6 bg-foreground-950 text-background-200">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <h3 className="font-heading font-bold text-background-50 text-lg mb-3">Sugargoo Sheet</h3>
            <p className="text-background-400 text-sm leading-relaxed">
              The ultimate independent resource for Sugargoo Spreadsheet finds, shopping guides, reviews and comparison tools.
            </p>
          </div>

          <div>
            <h3 className="font-heading font-bold text-background-50 text-lg mb-3">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-spreadsheet-guide" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">
                  Ultimate Spreadsheet Guide
                </Link>
              </li>
              <li>
                <Link to="/article/sugargoo-shipping-cost" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">
                  Shipping Cost Guide
                </Link>
              </li>
              <li>
                <Link to="/article/is-sugargoo-legit" className="text-background-400 hover:text-background-200 text-sm transition-colors cursor-pointer">
                  Is Sugargoo Legit?
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-bold text-background-50 text-lg mb-3">Disclaimer</h3>
            <p className="text-background-400 text-sm leading-relaxed">
              This website is an independent educational resource. We are not affiliated with Sugargoo. All trademarks belong to their respective owners.
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; {currentYear} Sugargoo Sheet. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-background-400 hover:text-background-200 transition-colors cursor-pointer">
              <i className="ri-global-line text-lg"></i>
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-background-400 hover:text-background-200 transition-colors cursor-pointer">
              <i className="ri-shopping-cart-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}